export enum FileType {
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
  FILE = 'file',
}
